export default __webpack_public_path__ + "static/media/HalfCircle1.5fb9b865.svg";